import { walletApi } from '@/services/instance';

// Secure file upload using existing API endpoint
export interface UploadParams {
  file: File;
  context: 'wallet' | 'notification' | 'survey';
  contextId?: string; // title/name for notification or survey
}

const getUploadPath = (context: string, contextId?: string): string => {
  switch (context) {
    case 'wallet':
      return 'wallet';
    case 'notification':
      return contextId ? `notification/${contextId}` : 'notification';
    case 'survey':
      return contextId ? `survey/${contextId}` : 'survey';
    default:
      return 'general';
  }
};

// Upload file using existing API
export const uploadBufferToS3 = async ({
  file,
  context,
  contextId,
}: UploadParams): Promise<{ key: string; url: string }> => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('path', getUploadPath(context, contextId));

    const response = await walletApi.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    const result = response.data;

    if (!result.success) {
      throw new Error(result.message || 'Upload failed');
    }

    return {
      key: result.data.key,
      url: result.data.url,
    };
  } catch (error) {
    console.error('File upload error:', error);
    throw error;
  }
};
